module.exports = __webpack_public_path__ + "assets/views/intro/intro_title_survival_ru.png";